import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

function Testimonials() {
  const data = [
    {
      id: 1,
      img: "assets/images/resources/testi-3-1.png",
      name: "Rajesh Sharma",
      subname: "Distributer",
      icon: "fab fa-twitter",
      desc: "I completed the entire process online in just a few minutes. The platform is simple, clear, and fast no paperwork or long calls needed.",
    },
    {
      id: 2,
      img: "assets/images/resources/testi-3-2.png",
      name: "Aman Bansal",
      subname: "Channel Partner",
      icon: "fab fa-pinterest-p",
      desc: "When I had a question about my health policy, their representative explained everything patiently and clearly.",
    },
    {
      id: 3,
      img: "assets/images/resources/testi-3-3.png",
      name: "Akash Gupta",
      subname: "Retailer",
      icon: "fab fa-twitter",
      desc: "Transparent plans, instant quotes, and no hidden charges everything was exactly as promised. I’ve already recommended Finreliable Insure to my friends.",
    },
    
    // {
    //   id: 6,
    //   img: "assets/images/resources/testi-3-3.png",
    //   name: "Wiley J. Schreffler",
    //   subname: "Marketing Officer",
    //   icon: "fab fa-twitter",
    //   desc: "",
    // },
    // {
    //   id: 7,
    //   img: "assets/images/resources/testi-3-1.png",
    //   name: "Richard M. Pappas",
    //   subname: "Senior Manager",
    //   icon: "fab fa-twitter",
    // },
    // {
    //   id: 8,
    //   img: "assets/images/resources/testi-3-2.png",
    //   name: "Zachariah M. Trower",
    //   subname: "Business Consultant",
    //   icon: "fab fa-pinterest-p",
    // },
    // {
    //   id: 9,
    //   img: "assets/images/resources/testi-3-3.png",
    //   name: "Wiley J. Schreffler",
    //   subname: "Marketing Officer",
    //   icon: "fab fa-twitter",
    // },
  ];

  return (
    <>
      <section className="testimonials-one testimonials-one--home-1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="sec-title text-center">
                <p className="sec-title__tagline">Clients testimonials</p>
                <h3 className="sec-title__title">What customers say about us</h3>
              </div>
              <Swiper
                spaceBetween={30} 
                slidesPerView={1} 
                loop={true}
                breakpoints={{
                  576: {
                    slidesPerView: 2, 
                  },
                  992: {
                    slidesPerView: 3, 
                  },
                }}
              >
                {data.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className="testimonials-card testimonials-card--two" style={{ "--accent-color": "#1da1f2" }}>
                      <div className="testimonials-card__top">
                        {/* <div className="testimonials-card__image">
                          <img src={item.img} alt={item.name} />
                        </div> */}
                        <div className="testimonials-card__top__content">
                          <h3 className="testimonials-card__name">{item.name}</h3>
                          <p className="testimonials-card__designation">{item.subname}</p>
                        </div>
                      </div>
                      <div className="testimonials-card__content">
                        {item.desc && <p style={{height: "100px"}} className="testimonials-card__text">{item.desc}</p>}
                      </div>
                      <div className="testimonials-card__bottom">
                        {/* <div className="testimonials-card__icon">
                          <i className={`${item.icon}`} />
                        </div> */}
                        <div className="testimonials-card__bottom__content">
                          <h3 className="testimonials-card__review">Quality Services</h3>
                          <p className="testimonials-card__stars">
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
